import {
    RETURN_LIST_RECEIVE,
    RETURN_LIST_ERROR,
    RETURN_LIST_CHANGE_MODE,
    RETURN_LIST_CHANGE_CURRENTPAGE,
    RETURN_LIST_SET_RETURN,
    RETURN_LIST_FILTER_CHANGE,
    RETURN_LIST_SET_SEARCH_TEXT,
    RETURN_LIST_SET_SORT_BY,

    RETURN_LIST_RECEIVE_CLOSED,
    RETURN_LIST_CHANGE_MODE_CLOSED,
    RETURN_LIST_CHANGE_CURRENTPAGE_CLOSED,
    RETURN_LIST_SET_RETURN_CLOSED,
    RETURN_LIST_FILTER_CHANGE_CLOSED,
    RETURN_LIST_SET_SEARCH_TEXT_CLOSED,
    RETURN_LIST_SET_SORT_BY_CLOSED,

    RETURN_RECEIVE,
    RETURN_SET_ERROR,
    RETURN_CHANGE_MODE,
    RETURN_RECEIVE_ORDER_ARTICLES
} from '../ConstantsBrafab/constants';

import {
    ViewMode
} from '../constants';
import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
    listMode: ViewMode.List,
    list: [],
    currentReturn: {},
    pendingReturn: {},
    filters: [],
    totalCount: 0,
    query: '',
    closedListMode: ViewMode.List,
    closedList: [],
    closedFilters: [],
    closedReturn: {},
    closedTotalCount: 0,
    errors: {},
    mode: ViewMode.List,
    closedQuery: '',
    orderArticles: [],
    classificationCodes: []
};

export const returnAuthorization = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case RETURN_LIST_RECEIVE:
        case RETURN_LIST_CHANGE_MODE:
        case RETURN_LIST_CHANGE_CURRENTPAGE:
        case RETURN_LIST_SET_RETURN:
        case RETURN_LIST_FILTER_CHANGE:
        case RETURN_LIST_SET_SEARCH_TEXT:
        case RETURN_LIST_SET_SORT_BY:
        case RETURN_LIST_RECEIVE_CLOSED:
        case RETURN_LIST_CHANGE_MODE_CLOSED:
        case RETURN_LIST_CHANGE_CURRENTPAGE_CLOSED:
        case RETURN_LIST_SET_RETURN_CLOSED:
        case RETURN_LIST_FILTER_CHANGE_CLOSED:
        case RETURN_LIST_SET_SEARCH_TEXT_CLOSED:
        case RETURN_LIST_SET_SORT_BY_CLOSED:
        case RETURN_RECEIVE:
        case RETURN_CHANGE_MODE:
        case RETURN_RECEIVE_ORDER_ARTICLES:
            return {
                ...state,
                errors: {},
                ...payload
            };
        case RETURN_LIST_ERROR:
        case RETURN_SET_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        default:
            return state;
    }
};
